import React from "react";

import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  NavbarText,
  Form,
  Input,
  Button,
} from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
// import cc from "./image/cc.jpg"
import { CgCircleci } from "react-icons/cg";
import { TfiShoppingCartFull } from "react-icons/tfi";

export default function CustNavbar() {
  return (
    <div>
      <Navbar color="dark" dark expand="md" fixed="" >
        <NavbarBrand  tag={Link} to="/">
          <CgCircleci /> CapCorner
        </NavbarBrand>

        <NavbarToggler />
        <Collapse navbar>
          <Nav className="me-auto" navbar>
            <NavItem>
              <NavLink tag={Link} to="/about">About US</NavLink>
            </NavItem>

            <UncontrolledDropdown nav inNavbar>
              <DropdownToggle nav caret>
                Products
              </DropdownToggle>
              <DropdownMenu right>
                <DropdownItem tag={Link} to="/cap">hats & caps</DropdownItem>
                <DropdownItem tag={Link} to="/eyewear">eyewear</DropdownItem>
                <DropdownItem tag={Link} to="/belt">Belt</DropdownItem>

                <DropdownItem tag={Link} to="/wallets">Wallets</DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          </Nav>
          {/* <Nav navbar>
            <Form className="class=" form-inline>
              <Input
                className="form-control mr-sm-2"
                type="search"
                placeholder="Search Product"
                aria-label="Search"
              />
              <Button type="submit" color="warning" outline>
                Search
              </Button>
               
            </Form>
            </Nav> */}
          <Nav navbar>
            <NavItem>
              <NavLink tag={Link} to="/cart">
                Cart <TfiShoppingCartFull />
              </NavLink>
            </NavItem>
          </Nav>
        </Collapse>
      </Navbar>
    </div>
  );
}
